import { defineMessages } from "react-intl";

/**
 * SFCC-11723 — i18n message catalog for the Learning Center GoalBanner blocks
 * (`goal-banner/*`). HSA-specific copy (e.g. "Your Lessons" explainer, "Perk
 * Points") is message-keyed so a per-site override is possible — pairs with the
 * per-site gating tracked in LC-GAP-06.
 */
const messages = defineMessages({
  selectGoal: {
    id: "learningCenter.goalBanner.select_goal",
    defaultMessage: "Please select a goal",
  },
  yourLessonsHeading: {
    id: "learningCenter.goalBanner.your_lessons_heading",
    defaultMessage: "Your Lessons",
  },
  yourLessonsBody: {
    id: "learningCenter.goalBanner.your_lessons_body",
    defaultMessage:
      "Complete more lessons to build your knowledge and get closer to your financial goals! And, get rewarded and earn <perkLink>Perk Points</perkLink> from HSA Store for completing your learning.",
  },
  levelHeading: {
    id: "learningCenter.goalBanner.level_heading",
    defaultMessage: "Level {levelNumber}",
  },
  enrollNow: {
    id: "learningCenter.goalBanner.enroll_now",
    defaultMessage: "Enroll Now",
  },
  enrollPrompt: {
    id: "learningCenter.goalBanner.enroll_prompt",
    defaultMessage: "to start earning Perk Points!",
  },
  maxEarned: {
    id: "learningCenter.goalBanner.max_earned",
    defaultMessage: "Yearly earning potential of {points} points achieved!",
  },
  earnedPoints: {
    id: "learningCenter.goalBanner.earned_points",
    defaultMessage: "You Earned {points} Points!",
  },
  potentialEarnings: {
    id: "learningCenter.goalBanner.potential_earnings",
    defaultMessage: "Potential Earnings: {points} Points!",
  },
  levelComplete: {
    id: "learningCenter.goalBanner.level_complete",
    defaultMessage: "Level complete!",
  },
  levelCompletePrompt: {
    id: "learningCenter.goalBanner.level_complete_prompt",
    defaultMessage: "Complete this level to earn Perk Points!",
  },
  ctaReview: {
    id: "learningCenter.goalBanner.cta_review",
    defaultMessage: "Review",
  },
  ctaContinue: {
    id: "learningCenter.goalBanner.cta_continue",
    defaultMessage: "Continue",
  },
  ctaGetStarted: {
    id: "learningCenter.goalBanner.cta_get_started",
    defaultMessage: "Get Started",
  },
});

export default messages;
